module.exports = __webpack_public_path__ + "static/media/whatsapp.1aa4b3ee.png";